const DASHBOARD_HEADINGS = Object.freeze({
    TOTAL_REGISTERED_DEVICE: "Total Registrations",
    OPEN_COMPLAINTS: "Open Complaints",
    RESOLVED: "Resolved Complaints",
    CUSTOMERS: "Total Customers"
});

export default DASHBOARD_HEADINGS;

export const COMPLAINT_HEADINGS = Object.freeze({
    TOTAL: "Total Complaints",
    RESOLVED: "Resolved Complaints",
    OPEN: "Open Complaints"
});

export const PRODUCT_HEADINGS = Object.freeze({
    TOTAL: "Total Registrations",
    ACTIVE_WARRANTIES: "Active Warranties",
    EXPIRING: "Expiring Soon",
    QR_REGISTRATIONS: "QR Registrations",
});

export const dateRangeOptions = [
    { label: "Last 30 Days", value: "last-30-days" },
];